const MAX_HEADING_LEVEL = 6;

function parseHeading(line: string): { level: number; text: string } | null {
  const trimmed = line.trimStart();
  let level = 0;
  while (level < trimmed.length && trimmed[level] === '#') level++;
  if (level === 0 || level > MAX_HEADING_LEVEL || trimmed[level] !== ' ') return null;
  const text = trimmed.slice(level + 1).trim();
  return text ? { level, text } : null;
}

/**
 * Builds the highlighted text's heading ancestry, shallowest → deepest (e.g. `["Income", "Bonus"]`),
 * by walking backwards and keeping only headings that strictly nest (each shallower than the last
 * kept), so a sibling branch's deeper heading isn't spliced in. Empty when the text isn't found.
 * A hint for the verify agent — `indexOf` takes the first match, which is fine for a hint.
 */
export function extractSectionPath(documentContent: string, highlightedText: string): string[] {
  if (!documentContent || !highlightedText) return [];
  const index = documentContent.indexOf(highlightedText);
  if (index === -1) return [];

  const linesBefore = documentContent.slice(0, index).split('\n');
  const ancestryDeepestFirst: string[] = [];
  let shallowestTaken = Number.POSITIVE_INFINITY;
  for (let i = linesBefore.length - 1; i >= 0; i--) {
    const heading = parseHeading(linesBefore[i]);
    if (heading && heading.level < shallowestTaken) {
      ancestryDeepestFirst.push(heading.text);
      shallowestTaken = heading.level;
    }
  }

  return ancestryDeepestFirst.reverse();
}
